import React from "react";
import FixButton from "../widgets/Button";
import getPresenze from "../services/getPresenze";
import addPresenza from "../services/addPresenza";
import deletePresenze from "../services/deletePresenze";
import getCorso from "../services/getCorso";
import getStudenti from "../services/getStudenti";
import SelectInput from "../widgets/SelectInput";
import getSessioniLezione from "../services/getSessioniLezione";
import TextInput from "../widgets/TextInput";

import Cookies from "universal-cookie";
import getLezioni from "../services/getLezioni";

class InnerPresenzaWidget extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: props.value || 0,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setState({
        value: this.props.value || 0,
      });
    }
  }

  setValue(val) {
    this.setState({
      value: val,
    });
    this.props.onChange && this.props.onChange(val);
  }

  render() {
    return (
      <div style={{ display: "flex", gap: "5px", justifyContent: "center" }}>
        <div
          style={this.state.value == -1 ? red : defaultButton}
          onClick={() => this.setValue(-1)}
        >
          Assente
        </div>
        <div
          style={this.state.value == 1 ? green : defaultButton}
          onClick={() => this.setValue(1)}
        >
          Presente
        </div>
      </div>
    );
  }
}

export default class PresenzeWidget extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      results: new Map(), // key: "studente_id" o "studente_id_sessione_id" -> value: presenza (-1, 0, 1)
      notes: new Map(), // key: "studente_id" o "studente_id_sessione_id" -> value: note (stringa)
      sessioniLezione: [],
    };
  }

  getValue() {
    let value = 0;
    return value;
  }

  async componentDidMount() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    const lezione = this.props.lezione;

    console.log("PresenzeWidget - Props corsi:", this.props.corsi);
    console.log("PresenzeWidget - Lezione completa:", lezione);

    const presenze = await getPresenze(username, token, lezione.id);
    this.studenti = await getStudenti(username, token);
    const lezioni = await getLezioni(username, token);

    // Carica le sessioni se la lezione è divisa
    const sessioniLezione = await getSessioniLezione(
      username,
      token,
      lezione.id
    );

    console.log("PresenzeWidget - Studenti caricati:", this.studenti.length);
    console.log("PresenzeWidget - Sessioni lezione:", sessioniLezione);

    this.corsiObj = {};

    for (var corso of this.props.corsi) {
      var tempCorso = await getCorso(username, token, corso);
      this.corsiObj[corso] = tempCorso;
      console.log("PresenzeWidget - Corso caricato:", corso, tempCorso);
      this.setState({});
    }

    this.studentiLezione = this.studenti.filter((s) => {
      var present = false;

      this.props.corsi.forEach((c) => {
        if (this.corsiObj[c] === undefined) return;
        // Supporta diversi formati: "123", "123;", "123,456", "123;456"
        const corsiList = s.corsi
          .split(/[;,]/)
          .map((corso) => corso.trim())
          .filter(Boolean);
        const isEnrolled = corsiList.includes(c.toString());
        const isWithdrawn = s.corsi_ritiro && s.corsi_ritiro.includes(c + ";");

        if (isEnrolled && !isWithdrawn) {
          present = true;
        }
      });

      return present;
    });

    console.log(
      "PresenzeWidget - Studenti lezione filtrati:",
      this.studentiLezione.length,
      this.studentiLezione
    );

    // Carica le presenze esistenti
    if (sessioniLezione.length > 0) {
      // Lezione divisa: usa chiave studente_sessione
      presenze.forEach((p) => {
        const key = `${p.id_studente}_${p.id_sessione || "null"}`;
        this.state.results.set(key, p.presenza);
        this.state.notes.set(key, p.note || ""); // Carica le note
      });
    } else {
      // Lezione normale: usa solo id studente
      presenze.forEach((p) => {
        this.state.results.set(p.id_studente, p.presenza);
        this.state.notes.set(p.id_studente, p.note || ""); // Carica le note
      });
    }

    // Imposta automaticamente a 0 (presente) tutti gli studenti che non hanno un valore
    if (sessioniLezione.length > 0) {
      // Per lezioni divise, crea chiavi per ogni sessione
      this.studentiLezione.forEach((studente) => {
        sessioniLezione.forEach((sessione) => {
          const key = `${studente.id}_${sessione.id}`;
          if (!this.state.results.has(key)) {
            this.state.results.set(key, 0);
            console.log(
              `PresenzeWidget - Impostato valore di default 0 per studente: ${studente.nome} ${studente.cognome} - Sessione ${sessione.ordine}`
            );
          }
        });
      });
    } else {
      // Per lezioni normali
      this.studentiLezione.forEach((studente) => {
        if (!this.state.results.has(studente.id)) {
          this.state.results.set(studente.id, 0);
          console.log(
            `PresenzeWidget - Impostato valore di default 0 per studente: ${studente.nome} ${studente.cognome}`
          );
        }
      });
    }

    this.setState({ sessioniLezione });
  }

  async handleSave() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    const lezione = this.props.lezione;
    const sessioniLezione = this.state.sessioniLezione;

    var studenti = this.studentiLezione;
    if (this.studentiRecupero && this.studentiRecupero.length > 0) {
      studenti = [...studenti, ...this.studentiRecupero];
    }

    // Verifica che tutti gli studenti abbiano una presenza registrata
    var errorNotFound = false;
    if (sessioniLezione.length > 0) {
      // Per lezioni divise, verifica tutte le sessioni
      studenti.forEach((s) => {
        sessioniLezione.forEach((sessione) => {
          const key = `${s.id}_${sessione.id}`;
          if (this.state.results.get(key) == undefined) errorNotFound = true;
        });
      });
    } else {
      // Per lezioni normali
      studenti.forEach((s) => {
        if (this.state.results.get(s.id) == undefined) errorNotFound = true;
      });
    }

    if (errorNotFound) {
      alert(
        "E' necessario segnare la presenza di TUTTI gli studenti per continuare"
      );
    } else {
      try {
        // Crea un array di promesse per salvare tutte le presenze
        const savePromises = [];

        if (sessioniLezione.length > 0) {
          // Lezione divisa: salva per ogni studente e ogni sessione
          studenti.forEach((s) => {
            sessioniLezione.forEach((sessione) => {
              const key = `${s.id}_${sessione.id}`;
              const presenza = this.state.results.get(key);
              const note = this.state.notes.get(key) || "";
              savePromises.push(
                addPresenza(
                  username,
                  token,
                  lezione.id,
                  s.id,
                  presenza,
                  sessione.id,
                  note
                ).then((resp) => {
                  console.log(resp);
                  if (resp.result === "KO") {
                    throw new Error(
                      `Errore nel salvare la presenza per ${s.nome} ${s.cognome} - Sessione ${sessione.ordine}`
                    );
                  }
                  return resp;
                })
              );
            });
          });
        } else {
          // Lezione normale: salva senza id_sessione
          studenti.forEach((s) => {
            const presenza = this.state.results.get(s.id);
            const note = this.state.notes.get(s.id) || "";
            savePromises.push(
              addPresenza(
                username,
                token,
                lezione.id,
                s.id,
                presenza,
                null,
                note
              ).then((resp) => {
                console.log(resp);
                if (resp.result === "KO") {
                  throw new Error(
                    `Errore nel salvare la presenza per ${s.nome} ${s.cognome}`
                  );
                }
                return resp;
              })
            );
          });
        }

        // Attende che tutte le promesse si completino
        await Promise.all(savePromises);

        alert("Salvataggio avvenuto con successo.");
        window.location.href = "#/app/schedule";
      } catch (error) {
        console.error("Errore durante il salvataggio:", error);
        alert(
          "Si è verificato un errore durante il salvataggio dei dati. Per favore, riprova."
        );
        return;
      }
    }
  }

  render() {
    // Aggiunge controlli per evitare crash se i dati non sono ancora caricati
    if (!this.studenti || !this.corsiObj) {
      return (
        <div style={widgetClass}>
          <div>Caricamento studenti...</div>
        </div>
      );
    }

    return (
      <>
        <div style={widgetClass}>
          {this.state.sessioniLezione.length > 0 && (
            <div
              style={{
                backgroundColor: "#fff3cd",
                border: "1px solid #ffc107",
                borderRadius: "5px",
                padding: "15px",
                margin: "0 0 20px 0",
                color: "#856404",
                textAlign: "center",
              }}
            >
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "16px",
                  marginBottom: "10px",
                }}
              >
                ℹ️ Questa lezione è divisa in due metà
              </div>
              <div style={{ fontSize: "14px" }}>
                Ogni studente ha due righe: una per la{" "}
                <strong style={{ color: "#2e7d32" }}>🌅 Prima metà</strong> e
                una per la{" "}
                <strong style={{ color: "#e65100" }}>🌆 Seconda metà</strong>
              </div>
            </div>
          )}

          {this.studenti &&
            this.props.corsi.map((corso) => {
              var studentiCorso = this.studenti.filter((s) => {
                // Supporta diversi formati per il campo corsi
                const corsiList = s.corsi
                  .split(/[;,]/)
                  .map((c) => c.trim())
                  .filter(Boolean);
                const isEnrolled = corsiList.includes(corso.toString());
                const isWithdrawn =
                  s.corsi_ritiro && s.corsi_ritiro.includes(corso + ";");
                return isEnrolled && !isWithdrawn;
              });

              console.log("Studenti corso", corso, ":", studentiCorso);
              console.log("Studenti recupero:", this.studentiRecupero);

              if (this.studentiRecupero && this.studentiRecupero.length > 0) {
                studentiCorso = [...studentiCorso, ...this.studentiRecupero];
              }

              if (corso === "") return null;
              if (this.corsiObj[corso] === undefined) return null;

              return (
                <div key={corso.name}>
                  <div style={{ textAlign: "center", fontSize: "25px" }}>
                    {this.corsiObj[corso].name}
                  </div>
                  <table style={mainClass}>
                    {/* Header solo per lezioni divise */}
                    {this.state.sessioniLezione.length > 0 && (
                      <thead>
                        <tr>
                          <th style={headerCell}>Studente</th>
                          <th style={headerCell}>
                            🌅 Prima Metà
                            <br />
                            <span
                              style={{ fontSize: "11px", fontWeight: "normal" }}
                            >
                              ({this.state.sessioniLezione[0]?.ora_inizio || ""}{" "}
                              - {this.state.sessioniLezione[0]?.ora_fine || ""})
                            </span>
                          </th>
                          <th style={headerCell}>Note Prima Metà</th>
                          <th style={headerCell}>
                            🌆 Seconda Metà
                            <br />
                            <span
                              style={{ fontSize: "11px", fontWeight: "normal" }}
                            >
                              ({this.state.sessioniLezione[1]?.ora_inizio || ""}{" "}
                              - {this.state.sessioniLezione[1]?.ora_fine || ""})
                            </span>
                          </th>
                          <th style={headerCell}>Note Seconda Metà</th>
                        </tr>
                      </thead>
                    )}
                    <tbody>
                      {studentiCorso
                        .sort((s1, s2) => {
                          if (
                            s1.cognome > s2.cognome ||
                            (s1.cognome === s2.cognome && s1.nome > s2.nome)
                          )
                            return 1;
                          else return -1;
                        })
                        .map((s) => {
                          // Se la lezione è divisa, mostra UNA riga con DUE colonne
                          if (this.state.sessioniLezione.length > 0) {
                            const sessioneMattina = this.state.sessioniLezione.find(
                              (sess) => sess.ordine === 1
                            );
                            const sessionePomeriggio = this.state.sessioniLezione.find(
                              (sess) => sess.ordine === 2
                            );

                            const keyMattina = `${s.id}_${sessioneMattina?.id}`;
                            const keyPomeriggio = `${s.id}_${sessionePomeriggio?.id}`;

                            return (
                              <tr key={s.id}>
                                <td>
                                  <p style={textMaxWidth}>
                                    {s.cognome + " " + s.nome}
                                  </p>
                                </td>
                                {/* Prima Metà (Mattina) */}
                                <td style={{ textAlign: "center" }}>
                                  <InnerPresenzaWidget
                                    value={this.state.results.get(keyMattina)}
                                    onChange={(val) => {
                                      this.setState({
                                        results: this.state.results.set(
                                          keyMattina,
                                          val
                                        ),
                                      });
                                    }}
                                  />
                                </td>
                                {/* Note Prima Metà */}
                                <td
                                  style={{
                                    textAlign: "center",
                                    padding: "5px",
                                  }}
                                >
                                  <TextInput
                                    type="text"
                                    value={
                                      this.state.notes.get(keyMattina) || ""
                                    }
                                    placeholder="Note..."
                                    onChange={(value) => {
                                      this.setState({
                                        notes: this.state.notes.set(
                                          keyMattina,
                                          value
                                        ),
                                      });
                                    }}
                                    style={{ width: "200px", fontSize: "12px" }}
                                  />
                                </td>
                                {/* Seconda Metà (Pomeriggio) */}
                                <td style={{ textAlign: "center" }}>
                                  <InnerPresenzaWidget
                                    value={this.state.results.get(
                                      keyPomeriggio
                                    )}
                                    onChange={(val) => {
                                      this.setState({
                                        results: this.state.results.set(
                                          keyPomeriggio,
                                          val
                                        ),
                                      });
                                    }}
                                  />
                                </td>
                                {/* Note Seconda Metà */}
                                <td
                                  style={{
                                    textAlign: "center",
                                    padding: "5px",
                                  }}
                                >
                                  <TextInput
                                    type="text"
                                    value={
                                      this.state.notes.get(keyPomeriggio) || ""
                                    }
                                    placeholder="Note..."
                                    onChange={(value) => {
                                      this.setState({
                                        notes: this.state.notes.set(
                                          keyPomeriggio,
                                          value
                                        ),
                                      });
                                    }}
                                    style={{ width: "200px", fontSize: "12px" }}
                                  />
                                </td>
                              </tr>
                            );
                          } else {
                            // Lezione normale: una riga per studente
                            return (
                              <tr key={s.id}>
                                <td>
                                  <p style={textMaxWidth}>
                                    {s.cognome + " " + s.nome}
                                  </p>
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  <InnerPresenzaWidget
                                    value={this.state.results.get(s.id)}
                                    onChange={(val) => {
                                      this.setState({
                                        results: this.state.results.set(
                                          s.id,
                                          val
                                        ),
                                      });
                                    }}
                                  />
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    padding: "5px",
                                  }}
                                >
                                  <TextInput
                                    type="text"
                                    value={this.state.notes.get(s.id) || ""}
                                    placeholder="Note..."
                                    onChange={(value) => {
                                      this.setState({
                                        notes: this.state.notes.set(
                                          s.id,
                                          value
                                        ),
                                      });
                                    }}
                                    style={{ width: "200px", fontSize: "12px" }}
                                  />
                                </td>
                              </tr>
                            );
                          }
                        })}
                    </tbody>
                  </table>
                </div>
              );
            })}

          <FixButton title={"Save"} callback={() => this.handleSave()} />
        </div>
      </>
    );
  }
}

const widgetClass = {
  border: "1px solid black",
  padding: "5px",
};

const mainClass = {
  padding: "5px",
};

const green = {
  border: "1px solid black",
  padding: "5px",
  background: "#00ff00",
};

const red = {
  border: "1px solid black",
  padding: "5px",
  background: "#ff0000",
};

const defaultButton = {
  border: "1px solid black",
  padding: "5px",
  background: "#ffffff",
  cursor: "pointer",
  height: "30px",
  width: "fit-content",
};

const textMaxWidth = {
  maxWidth: "120px",
  padding: "0px",
  margin: "0px",
};

const headerCell = {
  padding: "10px",
  backgroundColor: "#f5f5f5",
  border: "1px solid #ddd",
  textAlign: "center",
  fontWeight: "bold",
  fontSize: "14px",
};
